// The copy for ATLAS's own briefing on an order from Workfront, shared by the edit form and the
// details panel.

/** The heading and field label for ATLAS's own briefing on a Workfront order. */
export const ATLAS_NOTES_LABEL = 'ATLAS notes'

/** Supporting hint under ATLAS notes: clarifies that Workfront never touches this field. */
export const ATLAS_NOTES_HINT = 'Written in ATLAS. Workfront never changes it.'

/** Fallback text shown when a Workfront order has no briefing notes. */
export const ATLAS_NOTES_EMPTY = 'No notes.'
